export default __webpack_public_path__ + "static/media/timeline.cc1bd8bb.svg";